import React from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import FormattedText from '../../../../../common/formatted-text'

type ExplanationProps = {
    explanation: string
}

const Explanation: React.FunctionComponent<ExplanationProps> = ({ explanation }) => (
    <Container>
        <FormattedText text={explanation} />
    </Container>
)

const Container = styled.div`
    font-size: 14px;
    line-height: 22px;

    text-align: center;

    ${up('mobileBig')} {
        font-size: 16px;
        line-height: 28px;
    }

    ${up('desktop')} {
        text-align: left;
    }
`

export default Explanation